import defaultConfig, { LEFT, RIGHT } from '../default/config_default';
import { cloneDeep } from 'lodash';

let page = cloneDeep(defaultConfig);

page.imageSrc = 'background/strona_001.jpg';

page.games = [
  {
    id: 'page001_game0',
    pos: { x: RIGHT, y: 0 },
  },
  {
    id: 'page001_game1',
    pos: { x: RIGHT, y: 0 },
  },
  {
    id: 'page001_game2',
    pos: { x: RIGHT, y: 0 },
  },
  { id: 'page001_game3', pos: { x: RIGHT, y: 0 } },
  { id: 'page001_game4', pos: { x: RIGHT, y: 0 } },
  { id: 'page001_game5', pos: { x: RIGHT, y: 0 } },
  { id: 'page001_game6', pos: { x: RIGHT, y: 0 } },
  { id: 'page001_game7', pos: { x: RIGHT, y: 0 } },
  { id: 'page001_game8', pos: { x: RIGHT, y: 0 } },
  { id: 'page001_game9', pos: { x: RIGHT, y: 0 } },
];

page.gallery = [
  {
    id: 's1',
    pos: { x: LEFT, y: 0 },
    overflowDisabled: true,
    items: [
      {
        imageSrc: 'gallery/story1/1.webp',
        audio: {
          audioSrc: 'audio/story1/s1_1.mp3',
          pos: {
            x: 0.8,
            y: 1,
          },
        },
      },
      {
        imageSrc: 'gallery/story1/2.webp',
        audio: {
          audioSrc: 'audio/story1/s1_2.mp3',
          pos: {
            x: 0.8,
            y: 1,
          },
        },
      },
      {
        imageSrc: 'gallery/story1/3.webp',
        audio: {
          audioSrc: 'audio/story1/s1_3.mp3',
          pos: {
            x: 0.8,
            y: 1,
          },
        },
      },
      {
        imageSrc: 'gallery/story1/4.webp',
        audio: {
          audioSrc: 'audio/story1/s1_4.mp3',
          pos: {
            x: 0.8,
            y: 1,
          },
        },
      },
    ],
  },
  {
    id: 's2',
    overflowDisabled: true,
    pos: { x: LEFT, y: 0 },
    items: [
      {
        imageSrc: 'gallery/story2/1.webp',
        audio: {
          audioSrc: 'audio/story2/s2_1.mp3',
          pos: {
            x: 0.8,
            y: 1,
          },
        },
      },
      {
        imageSrc: 'gallery/story2/2.webp',
        audio: {
          audioSrc: 'audio/story2/s2_2.mp3',
          pos: {
            x: 0.8,
            y: 1,
          },
        },
      },
      {
        imageSrc: 'gallery/story2/3.webp',
        audio: {
          audioSrc: 'audio/story2/s2_3.mp3',
          pos: {
            x: 0.8,
            y: 1,
          },
        },
      },
      {
        imageSrc: 'gallery/story2/4.webp',
        audio: {
          audioSrc: 'audio/story2/s2_4.mp3',
          pos: {
            x: 0.8,
            y: 1,
          },
        },
      },
    ],
  },
  {
    id: 's3',
    overflowDisabled: true,
    pos: { x: LEFT, y: 0 },
    items: [
      {
        imageSrc: 'gallery/story3/1.webp',
        audio: {
          audioSrc: 'audio/story3/14.1.mp3',
          pos: {
            x: 0.8,
            y: 1,
          },
        },
      },
      {
        imageSrc: 'gallery/story3/2.webp',
        audio: {
          audioSrc: 'audio/story3/14.2.mp3',
          pos: {
            x: 0.8,
            y: 1,
          },
        },
      },
      {
        imageSrc: 'gallery/story3/3.webp',
        audio: {
          audioSrc: 'audio/story3/14.3.mp3',
          pos: {
            x: 0.8,
            y: 1,
          },
        },
      },
      {
        imageSrc: 'gallery/story3/4.webp',
        audio: {
          audioSrc: 'audio/story3/14.4.mp3',
          pos: {
            x: 0.8,
            y: 1,
          },
        },
      },
    ],
  },
  {
    id: 's4',
    overflowDisabled: true,
    pos: { x: LEFT, y: 0 },
    items: [
      {
        imageSrc: 'gallery/story4/1.webp',
        audio: {
          audioSrc: 'audio/story4/17.1.mp3',
          pos: {
            x: 0.8,
            y: 1,
          },
        },
      },
      {
        imageSrc: 'gallery/story4/2.webp',
        audio: {
          audioSrc: 'audio/story4/17.2.mp3',
          pos: {
            x: 0.8,
            y: 1,
          },
        },
      },
      {
        imageSrc: 'gallery/story4/3.webp',
        audio: {
          audioSrc: 'audio/story4/17.3.mp3',
          pos: {
            x: 0.8,
            y: 1,
          },
        },
      },
      {
        imageSrc: 'gallery/story4/4.webp',
        audio: {
          audioSrc: 'audio/story4/17.4.mp3',
          pos: {
            x: 0.8,
            y: 1,
          },
        },
      },
    ],
  },
  {
    id: 's5',
    overflowDisabled: true,
    pos: { x: LEFT, y: 0 },
    items: [
      {
        imageSrc: 'gallery/story5/1.webp',
        audio: {
          audioSrc: 'audio/story5/20.1.mp3',
          pos: {
            x: 0.8,
            y: 1,
          },
        },
      },
      {
        imageSrc: 'gallery/story5/2.webp',
        audio: {
          audioSrc: 'audio/story5/20.2.mp3',
          pos: {
            x: 0.8,
            y: 1,
          },
        },
      },
      {
        imageSrc: 'gallery/story5/3.webp',
        audio: {
          audioSrc: 'audio/story5/20.3.mp3',
          pos: {
            x: 0.8,
            y: 1,
          },
        },
      },
      {
        imageSrc: 'gallery/story5/4.webp',
        audio: {
          audioSrc: 'audio/story5/20.4.mp3',
          pos: {
            x: 0.8,
            y: 1,
          },
        },
      },
    ],
  },
  {
    id: 's6',
    overflowDisabled: true,
    pos: { x: LEFT, y: 0 },
    items: [
      {
        imageSrc: 'gallery/story6/1.webp',
        audio: {
          audioSrc: 'audio/story6/23.1.mp3',
          pos: {
            x: 0.8,
            y: 1,
          },
        },
      },
      {
        imageSrc: 'gallery/story6/2.webp',
        audio: {
          audioSrc: 'audio/story6/23.2.mp3',
          pos: {
            x: 0.8,
            y: 1,
          },
        },
      },
      {
        imageSrc: 'gallery/story6/3.webp',
        audio: {
          audioSrc: 'audio/story6/23.3.mp3',
          pos: {
            x: 0.8,
            y: 1,
          },
        },
      },
      {
        imageSrc: 'gallery/story6/4.webp',
        audio: {
          audioSrc: 'audio/story6/23.4.mp3',
          pos: {
            x: 0.8,
            y: 1,
          },
        },
      },
    ],
  },
  {
    id: 's7',
    overflowDisabled: true,
    pos: { x: LEFT, y: 0 },
    items: [
      {
        imageSrc: 'gallery/story7/1.webp',
        audio: {
          audioSrc: 'audio/story7/26.1.mp3',
          pos: {
            x: 0.8,
            y: 1,
          },
        },
      },
      {
        imageSrc: 'gallery/story7/2.webp',
        audio: {
          audioSrc: 'audio/story7/26.2.mp3',
          pos: {
            x: 0.8,
            y: 1,
          },
        },
      },
      {
        imageSrc: 'gallery/story7/3.webp',
        audio: {
          audioSrc: 'audio/story7/26.3.mp3',
          pos: {
            x: 0.8,
            y: 1,
          },
        },
      },
      {
        imageSrc: 'gallery/story7/4.webp',
        audio: {
          audioSrc: 'audio/story7/26.4.mp3',
          pos: {
            x: 0.8,
            y: 1,
          },
        },
      },
    ],
  },
  {
    id: 's8',
    overflowDisabled: true,
    pos: { x: LEFT, y: 0 },
    items: [
      {
        imageSrc: 'gallery/story8/1.webp',
        audio: {
          audioSrc: 'audio/story8/29.1.mp3',
          pos: {
            x: 0.8,
            y: 1,
          },
        },
      },
      {
        imageSrc: 'gallery/story8/2.webp',
        audio: {
          audioSrc: 'audio/story8/29.2.mp3',
          pos: {
            x: 0.8,
            y: 1,
          },
        },
      },
      {
        imageSrc: 'gallery/story8/3.webp',
        audio: {
          audioSrc: 'audio/story8/29.3.mp3',
          pos: {
            x: 0.8,
            y: 1,
          },
        },
      },
      {
        imageSrc: 'gallery/story8/4.webp',
        audio: {
          audioSrc: 'audio/story8/29.4.mp3',
          pos: {
            x: 0.8,
            y: 1,
          },
        },
      },
    ],
  },
  {
    id: 's9',
    overflowDisabled: true,
    pos: { x: LEFT, y: 0 },
    items: [
      {
        imageSrc: 'gallery/story9/1.webp',
        audio: {
          audioSrc: 'audio/story9/32.1.mp3',
          pos: {
            x: 0.8,
            y: 1,
          },
        },
      },
      {
        imageSrc: 'gallery/story9/2.webp',
        audio: {
          audioSrc: 'audio/story9/32.2.mp3',
          pos: {
            x: 0.8,
            y: 1,
          },
        },
      },
      {
        imageSrc: 'gallery/story9/3.webp',
        audio: {
          audioSrc: 'audio/story9/32.3.mp3',
          pos: {
            x: 0.8,
            y: 1,
          },
        },
      },
      {
        imageSrc: 'gallery/story9/4.webp',
        audio: {
          audioSrc: 'audio/story9/32.4.mp3',
          pos: {
            x: 0.8,
            y: 1,
          },
        },
      },
    ],
  },
  {
    id: 's10',
    overflowDisabled: true,
    pos: { x: LEFT, y: 0 },
    items: [
      {
        imageSrc: 'gallery/story10/1.webp',
        audio: {
          audioSrc: 'audio/story10/35.1.mp3',
          pos: {
            x: 0.8,
            y: 1,
          },
        },
      },
      {
        imageSrc: 'gallery/story10/2.webp',
        audio: {
          audioSrc: 'audio/story10/35.2.mp3',
          pos: {
            x: 0.8,
            y: 1,
          },
        },
      },
      {
        imageSrc: 'gallery/story10/3.webp',
        audio: {
          audioSrc: 'audio/story10/35.3.mp3',
          pos: {
            x: 0.8,
            y: 1,
          },
        },
      },
      {
        imageSrc: 'gallery/story10/4.webp',
        audio: {
          audioSrc: 'audio/story10/35.4.mp3',
          pos: {
            x: 0.8,
            y: 1,
          },
        },
      },
    ],
  },
];

export default page;
